<span class="detail-activity__label"><ng-container i18n="@@ASSETS_LAST_EDIT_LABEL">Last edit</ng-container>:</span>
<span class="detail-activity__value">
  @if (editedAt()) {
    {{ editedAt() | detailActivityDate }}, {{ editedBy() }}
  } @else {
    -
  }
</span>
@if (createdAt()) {
  <span class="detail-activity__label"><ng-container i18n="@@CREATED">Created</ng-container>:</span>
  <span class="detail-activity__value">{{ createdAt() | detailActivityDate }}, {{ createdBy() }}</span>
}
